<template>
  <div class="row f-row">
    <div class="col col-12">
      <!-- ============= Logo / title =============  -->
      <div
        class="row f-row text-center"
        style="border-bottom: 1px solid var(--graylightbackground);"
      >
        <div class="col col-12 mt-4 mb-3">
          <img
            :src="logo"
            @mouseover="logo = logo_blue"
            @mouseout="logo = logo_white"
            height="50"
            alt=""
            style="padding: 0"
          />
        </div>
      </div>
      <!-- ============= form =============  -->
      <div class="row f-row text-center">
        <div class="col col-12 mt-5 mb-5">
          Are You sure you want to Cancel the Quote?
        </div>
      </div>
      <div class="row f-row justify-content-center">
        <div class="col col-4">
          <button
            v-on:click="onUserStopQuote"
            style="width: 100%; height: 45px"
            class="btn btn-home"
          >
            Cancel quote
          </button>
        </div>
        <div class="col col-1"></div>
        <div class="col col-4">
          <button
            v-on:click="onUserContinueQuote"
            style="width: 100%; height: 45px"
            class="btn btn-home"
          >
            Continue quote
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CancelQuoteModal",
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
  },
  data() {
    return {
      logo: require("@/assets/images/symbol_white.svg"),
      logo_blue: require("@/assets/images/symbol_blue.svg"),
      logo_white: require("@/assets/images/symbol_white.svg"),
    };
  },
  mounted() {
    if (!this.colorTheme) {
      this.logo_white = require("@/assets/images/symbol_black.svg");
      this.logo = require("@/assets/images/symbol_black.svg");
    }
  },
  watch: {
    colorTheme(val) {
      if (val) {
        this.logo_white = require("@/assets/images/symbol_white.svg");
        this.logo = require("@/assets/images/symbol_white.svg");
      } else {
        this.logo_white = require("@/assets/images/symbol_black.svg");
        this.logo = require("@/assets/images/symbol_black.svg");
      }
    },
  },
  methods: {
    onUserStopQuote() {
      this.$emit("eventOnUserStopQuote");
    },
    onUserContinueQuote() {
      this.$emit("eventOnUserContinueQuote");
    },
  },
};
</script>
